<div class="feature-quote-list-container">
  <div class="content">
    <div class="header">
      <div class="heading">{{ 'basket.headers.features' | translate }}</div>
      <div class="heading singleprice hideOnPhone"> {{ 'basket.headers.price' | translate }}</div>
    </div>
    <div class="body">
      <div class="feature" *ngIf="deviceCart">
        <kion-feature-quote-list-item
          *ngFor="let entry of deviceCart.entries"
          [entry]="entry"
          [roles]="roles"
          [features]="device?.products ?? []"
          [deviceFeatures]="features"
          (deleteFeature)="deleteFeatureClicked($event)"
          [disableDelete]="disableDelete"
          [disableHealthyCheck]="disableHealthyCheck"
        ></kion-feature-quote-list-item>
      </div>
    </div>
  </div>
</div>
